const BID_LEVEL_THEMES = [
  'contractor',
  'team',
  'builder',
  'preClassEducation',
  'training',
  'examine',
  'attendance',
  'notice',
  'salaryPay',
  'contract',
  'division',
  'progress',
  'billOfQuantities',
  'safetyInput',
  'officialCar',
  'pouringOrder',
  'goodsShipment',
  'waterwheelWork',
  'concealedWork',
  'onlineExam',
  'trainingMaterials'
]

const ALLOWED_KEYS = [
  '查看',
  '详情',
  '明细',
  '预览',
  '附件',
  '二维码',
  '整改',
  '签到',
  '输入签到人数',
  '监控',
  '结果',
  '考卷'
]

function getButtonName(button) {
  if (button == null) return ''
  if (typeof button === 'string') return button
  return button.name || button.buttonName || ''
}

export function isLaborCompanyOrg(orgType) {
  return orgType === 'laborCom' || orgType === '劳务分包'
}

export function isBuilderPersonOfCurrentOrg(item, orgType, orgValue) {
  if (!item) return false
  // 劳务公司级列表已按本单位过滤，本页人员均视为当前劳务公司人员
  if (isLaborCompanyOrg(orgType)) return true
  if (!orgValue) return false
  const current = String(orgValue)
  if (orgType === 'simPro') {
    return (
      String(item.orgUid || '') === current ||
      String(item.vProjectUid || item.vprojectuid || '') === current ||
      String(item.projectUid || item.projectuid || '') === current
    )
  }
  return false
}

function getCurrentOrganization(params) {
  if (!params) return {}
  const orgValue = params.orgValue || ''
  let organization = {}
  if (params.getters) {
    organization =
      params.getters['user/organization'] || params.getters.organization || {}
  }
  if (!organization.orgUid && params.state && params.state.user) {
    const orgs = params.state.user.organizations || []
    organization = orgs.find((item) => item.orgUid === orgValue) || organization
  }
  return organization
}

function leafOrgName(text) {
  const value = String(text || '')
    .replace(/\(退场\)|（退场）/g, '')
    .trim()
  if (!value) return ''
  const parts = value.split('/').map((item) => item.trim()).filter(Boolean)
  return parts.length ? parts[parts.length - 1] : value
}

export function getLaborParentBidOrg(params) {
  const organization = getCurrentOrganization(params)
  const upList = organization.upOrg || []
  return (
    upList.find(
      (org) =>
        org.professionalNature === '管控' &&
        org.professionalType === '直属标段'
    ) ||
    upList.find((org) => org.professionalType === '直属标段') ||
    null
  )
}

export function getLaborParentBidUid(params) {
  const organization = getCurrentOrganization(params)
  const bid = getLaborParentBidOrg(params)
  return (
    (bid && (bid.orgUid || bid.uid)) ||
    organization.projectUid ||
    organization.upbidSectionUid ||
    organization.parentUid ||
    organization.upVproUid ||
    ''
  )
}

export function getLaborParentBidName(params) {
  const bid = getLaborParentBidOrg(params)
  if (bid) {
    return leafOrgName(bid.orgCode || bid.orgName || bid.label)
  }
  return ''
}

/** 劳务公司本级名称，不含上级项目标段路径 */
export function getLaborCompanyName(params) {
  const organization = getCurrentOrganization(params)
  return leafOrgName(
    organization.orgName ||
      organization.vname ||
      organization.orgCode ||
      (params && params.orgName)
  )
}

function walkPages(nodes, matcher) {
  if (!nodes) return false
  const list = Array.isArray(nodes) ? nodes : [nodes]
  return list.some((item) => {
    if (!item) return false
    if (matcher(item)) return true
    return walkPages(item.children, matcher)
  })
}

function isNamedPage(item, pageName) {
  if (!item || !pageName) return false
  if (item.name === pageName) return true
  const path = String(item.path || '')
  return (
    path === '/' + pageName ||
    path === '/workbench/' + pageName ||
    path.endsWith('/' + pageName)
  )
}

export function hasWorkbenchPage(params, pageName) {
  if (!params || !pageName) return false
  const getters = params.getters || {}
  const state = params.state || {}
  const user = state.user || {}
  const orgPages =
    (user.userPages || []).find((item) => item && item.orgUid === params.orgValue) ||
    {}
  return (
    walkPages(getters['user/pages'], (item) => isNamedPage(item, pageName)) ||
    walkPages(getters['user/workbenchApp'], (item) => isNamedPage(item, pageName)) ||
    walkPages(orgPages.pages, (item) => isNamedPage(item, pageName))
  )
}

export function hasBuilderModule(params) {
  return hasWorkbenchPage(params, 'builder')
}

export function isBidQueryField(field) {
  if (!field) return false
  const label = String(field.label || '')
  const key = String(field.key || '')
  if (
    label.indexOf('项目标段') >= 0 ||
    label.indexOf('项目/标段') >= 0
  ) {
    return true
  }
  return (
    key === 'vProjectUid' ||
    key === 'upVproUid' ||
    key === 'vprojectUid'
  )
}

export function findLaborCompanyQueryField(fields) {
  if (!Array.isArray(fields)) return null
  return (
    fields.find((item) => {
      return String((item && item.label) || '').indexOf('劳务公司') >= 0
    }) || null
  )
}

export function findTeamQueryField(fields) {
  if (!Array.isArray(fields)) return null
  return (
    fields.find((item) => {
      const label = String((item && item.label) || '')
      return label.indexOf('班组') >= 0 && label.indexOf('劳务') < 0
    }) || null
  )
}

export function isEnterpriseViewOrg(orgType) {
  return orgType === 'com' || orgType === 'bigPro'
}

export const TZ_INSPECTION_ORG_NAME = '甘肃省特种设备检验检测研究院'

export function isTzOrgName(text) {
  return String(text || '').trim() === TZ_INSPECTION_ORG_NAME
}

export function isTzInspectionOrg(params) {
  if (!params) return false
  const org = getCurrentOrganization(params)
  return [
    params.orgName,
    params.orgCode,
    org.orgName,
    org.orgCode,
    org.vname
  ].some((item) => isTzOrgName(item))
}

export function isTzInspectionSession(rootGetters) {
  const org = (rootGetters && rootGetters['user/organization']) || {}
  return (
    isTzOrgName(rootGetters && rootGetters['user/orgName']) ||
    isTzOrgName(org.orgName) ||
    isTzOrgName(org.orgCode)
  )
}

export function isOfficialCarEnterpriseDirect(state) {
  if (!state) return true
  const tab = state.currentTab || {}
  const step = (state.currentStep && state.currentStep.step) || ''
  const key =
    step.indexOf('fixedEquipment') === 0 ||
    tab.label === '固定机械' ||
    tab.label === '固定设备'
      ? 'fixedEquipment'
      : 'officialCar'
  const q = (state.queryValues && state.queryValues[key]) || {}
  if (q.vprojectUid == null || q.vprojectUid === '') return true
  return isEnterpriseDirectValue(q.vprojectUid)
}

export const ENTERPRISE_DIRECT_VALUE = 'enterpriseDirect'

export function isEnterpriseDirectValue(value) {
  return (
    value === ENTERPRISE_DIRECT_VALUE ||
    value === '企业直管或租赁'
  )
}

export function withEnterpriseDirectBidOption(options, orgType) {
  const bids = Array.isArray(options) ? options.slice() : []
  if (!isEnterpriseViewOrg(orgType)) return bids
  if (
    bids.some(
      (item) =>
        item &&
        (item.value === ENTERPRISE_DIRECT_VALUE ||
          item.label === '企业直管或租赁')
    )
  ) {
    return bids
  }
  return [
    {
      label: '企业直管或租赁',
      value: ENTERPRISE_DIRECT_VALUE,
      orgUid: ENTERPRISE_DIRECT_VALUE
    }
  ].concat(bids)
}

export function applyProjectDeviceTitle(item, orgType) {
  if (!item || item.name !== 'officialCar' || !isEnterpriseViewOrg(orgType)) {
    return item
  }
  const meta = Object.assign({}, item.meta || {}, {
    title: '项目设备'
  })
  return Object.assign({}, item, {
    pageName: '项目设备',
    meta
  })
}

export function isBidLevelViewOnly(orgType, theme, state) {
  if (!orgType || BID_LEVEL_THEMES.indexOf(theme) === -1) return false
  if (orgType === 'simPro') return false
  // 企业级在培训资料模块保留新增、编辑、删除与公共资料库入口
  if (theme === 'trainingMaterials' && isEnterpriseViewOrg(orgType)) {
    return false
  }
  // 班前教育：企业/标段/劳务公司三级各自控制按钮，不走上级只读过滤
  if (theme === 'preClassEducation') return false
  // 作业班组、参建人员：劳务公司级可新增/进场/编辑/退场等
  if (
    (theme === 'team' || theme === 'builder') &&
    isLaborCompanyOrg(orgType)
  ) {
    return false
  }
  // 机械设备：劳务公司级可进场及维护保险/保养/参数/监控
  if (theme === 'officialCar' && isLaborCompanyOrg(orgType)) {
    return false
  }
  // 企业级项目设备在「企业直管或租赁」下维护本机构进场，选下级标段仍只读
  if (
    theme === 'officialCar' &&
    isEnterpriseViewOrg(orgType) &&
    isOfficialCarEnterpriseDirect(state)
  ) {
    return false
  }
  return true
}

export function isAllowedBidLevelAction(button, orgType, theme) {
  const name = String(getButtonName(button))
  if (!name) return false
  // 企业级班前教育：可查看签到名单，不可录入签到
  if (
    theme === 'preClassEducation' &&
    isEnterpriseViewOrg(orgType) &&
    (name === '输入签到人数' || name === '批量签到' || name === '签到')
  ) {
    return false
  }
  // 在线考试组卷选题：创建/导入/搜索添加试题
  if (
    theme === 'onlineExam' &&
    (name.indexOf('创建试题') !== -1 ||
      name.indexOf('导入试题') !== -1 ||
      name.indexOf('添加到试卷') !== -1 ||
      name === '搜索添加')
  ) {
    return true
  }
  return ALLOWED_KEYS.some((key) => name.indexOf(key) !== -1)
}

export function filterBidLevelButtons(buttons, orgType, theme) {
  if (!buttons) return buttons
  if (typeof buttons === 'function') {
    return function filteredBidLevelButtons(row) {
      return filterBidLevelButtons(buttons(row), orgType, theme)
    }
  }
  if (!Array.isArray(buttons)) return buttons
  return buttons
    .map((btn, index) => {
      if (btn && typeof btn === 'object') {
        return Object.assign({}, btn, { originIndex: index })
      }
      return { name: btn, originIndex: index }
    })
    .filter((btn) => isAllowedBidLevelAction(btn, orgType, theme))
}

export function applyBidLevelActionFilter(data, orgType, theme, state) {
  if (!data || !isBidLevelViewOnly(orgType, theme, state)) return data
  if (data.headButtons) {
    data.headButtons = filterBidLevelButtons(data.headButtons, orgType, theme)
  }
  if (data.rowButtons) {
    data.rowButtons = filterBidLevelButtons(data.rowButtons, orgType, theme)
  }
  if (data.columns && Array.isArray(data.columns)) {
    data.columns.forEach((col) => {
      if (col && col.buttons) {
        col.buttons = filterBidLevelButtons(col.buttons, orgType, theme)
      }
    })
  }
  if (data.formData && data.formData.headButtons) {
    data.formData.headButtons = filterBidLevelButtons(
      data.formData.headButtons,
      orgType,
      theme
    )
  }
  return data
}

const BLOCKED_KEYS = [
  '新增',
  '新建',
  '添加',
  '进场',
  '编辑',
  '编制',
  '修改',
  '删除',
  '关联人员',
  '关联机械',
  '关联劳务',
  '退场',
  '解散',
  '签到',
  '打卡',
  '导入',
  '发布',
  '执行',
  '报备',
  '变更',
  '结算',
  '确认',
  '审核',
  '审批',
  '发车',
  '结束作业',
  '验收',
  '填报',
  '对接',
  '补方',
  '挂接',
  '复核',
  '分批',
  '兑换',
  '推送',
  '保存'
]

export function isBlockedBidLevelAction(orgType, theme, button, state) {
  if (!isBidLevelViewOnly(orgType, theme, state)) return false
  const name = String(getButtonName(button))
  if (!name) return false
  if (name.indexOf('整改') !== -1 || name.indexOf('查看') !== -1) return false
  if (
    theme === 'preClassEducation' &&
    isEnterpriseViewOrg(orgType) &&
    (name === '输入签到人数' || name === '批量签到' || name === '签到')
  ) {
    return true
  }
  if (name.indexOf('签到') !== -1) return false
  return BLOCKED_KEYS.some((key) => name.indexOf(key) !== -1)
}
